/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Auto_RetargetInputs */

const cs_sklik_auto_retarget = /** @type {(inputs: Sklik_Auto_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat e-maily leadů se souhlasem do retargetingového seznamu`)
};

const en_sklik_auto_retarget = /** @type {(inputs: Sklik_Auto_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add consented lead emails to the retargeting list`)
};

/**
* | output |
* | --- |
* | "Add consented lead emails to the retargeting list" |
*
* @param {Sklik_Auto_RetargetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_auto_retarget = /** @type {((inputs?: Sklik_Auto_RetargetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Auto_RetargetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_auto_retarget(inputs)
	return cs_sklik_auto_retarget(inputs)
});